import React, { useEffect, useRef } from "react";
import BillingSection from "./Sections/BillingSection";
import LeadAutomator from "./Sections/LeadAutomator";
import InvestorOutreach from "./Sections/InvestorOutreach";
import PlanSection from "./Sections/PlanSection";
import PrepaidCreditsSection from "./Sections/PrepaidCreditsSection";
import ProfileSection from "./Sections/ProfileSection";
import TeamSection from "./Sections/TeamSection";
import UsageSections from "./Sections/UsageSections";
import MarketingProfileSections from "./Sections/MarketingProfileSections";
import css from "./style.scss";
import AccountHeader from "./AccountHeader";
import { selecFullAccount } from "data/user/selectors";
import { useSelector } from "react-redux";
import BatchDialerSection from "./Sections/BatchDialerSection";
import CallSettingSection from "./Sections/CallSettingSection";

const MainPage = ({ children }) => {

  return (
    <>
      {/* header code */}
      <div className={css.clsPageWrapper}>
        <AccountHeader />
        <div className={css.clsBodyMain}>{children}</div>
      </div>
    </>
  );
};

export const LandingPage = () => {
  const isFullAccount = useSelector(selecFullAccount);

  const batchDialerRef = useRef(null);


  useEffect(() => {
    const key = "scrollToIntegrations";
    const shouldScroll = localStorage.getItem(key);
    if (!shouldScroll) return;

    let tries = 0;
    const maxTries = 60;
    const intervalMs = 100;
    let timer = null;

    const attempt = () => {
      tries += 1;
      const node = batchDialerRef.current || document.getElementById("integrations");

      if (node) {
        try {
          node.scrollIntoView({ behavior: "smooth", block: "start" });
        } catch (e) {
          // fallback to instant scroll if smooth is not supported
          node.scrollIntoView(true);
        }
        localStorage.removeItem(key);
      } else if (tries < maxTries) {
        timer = setTimeout(attempt, intervalMs);
      } else {
        // give up after timeout and remove flag
        localStorage.removeItem(key);
      }
    };

    timer = setTimeout(attempt, 50);

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, []);

  return (
    <>
      {isFullAccount ? (
        <div className={css.clsCardsMain}>
          <div className={css.clsCardsLeft}>
            <ProfileSection isFullAccount={isFullAccount} />

          </div>
          <div className={css.clsCardsRight}>
            <UsageSections isFullAccount={isFullAccount} />
            <LeadAutomator isFullAccount={isFullAccount} />
            <InvestorOutreach isFullAccount={isFullAccount} />
          </div>
        </div>
      ) : (
        <div className={css.clsCardsMain}>
          <div className={css.clsCardsLeft}>
            <ProfileSection />
            <MarketingProfileSections />
            <PrepaidCreditsSection />
            <BillingSection />
          </div>
          <div className={css.clsCardsRight}>
            <PlanSection />
            <UsageSections />
            <LeadAutomator />
            <InvestorOutreach />
            <TeamSection />
            <CallSettingSection />
            <BatchDialerSection ref={batchDialerRef} />

          </div>
        </div>
      )}
    </>
  );
};

export default MainPage;
